import { ILangProvider } from './interfaces';
import { globalLanguageDebugMode } from './global-language-debug';

export function glossaryProcessor(languageProvider: ILangProvider, key: string, optionValue?: string) {
  const keyParts = key.split(':');
  try {
    let glossaryValue =
      keyParts.length === 1
        ? languageProvider.getEntry(`glossary.${keyParts[0]}`)
        : languageProvider.getEntry(`glossary.${keyParts[0]}`, keyParts[1]);

    if (typeof optionValue === 'string' && optionValue) {
      switch (optionValue.toLowerCase()) {
        case 'lc': // make first letter lowercase
          glossaryValue = glossaryValue.toLowerCase();
          break;
        case 'uc': // uppercase
          glossaryValue = glossaryValue.toUpperCase();
          break;
        case 'lw': // lowercase each word's first letter
          glossaryValue = glossaryValue.replace(/\b\w/g, char => char.toLowerCase());
          break;
        case 'uw': // uppercase each word's first letter
          glossaryValue = glossaryValue.replace(/\b\w/g, char => char.toUpperCase());
          break;
      }
    }

    return globalLanguageDebugMode() ? `~${glossaryValue}~` : glossaryValue;
  } catch {
    return `glossary.${key}`;
  }
}
